// Textos fijos de la interfaz (botones, etiquetas, mensajes).
// El contenido editable (descripciones, proyectos...) está en src/content.
export const textos = {
  es: {
    saltarContenido: "Saltar al contenido",
    menuAbrir: "Abrir menú",
    menuCerrar: "Cerrar menú",
    navPrincipal: "Principal",
    inicio: "inicio",
    nav: { sobreMi: "Sobre mí", proyectos: "Proyectos", skills: "Skills", contacto: "Contacto" },
    cv: "CV",
    descargarCv: "Descargar CV",
    // Se usan cuando el CV ofrecido está en otro idioma (no aplica en español)
    cvOtroIdioma: "CV",
    descargarCvOtroIdioma: "Descargar CV",
    verProyectos: "Ver proyectos",
    verTodos: "Ver todos",
    verDemo: "Ver demo",
    codigo: "Código",
    de: "de",
    abreNuevaPestana: "abre en otra pestaña",
    capturaDe: "Captura de",
    tecnologias: "Tecnologías",
    volverInicio: "Volver al inicio",
    todosLosProyectos: "Todos los proyectos",
    filtrarPorTecnologia: "Filtrar por tecnología",
    todas: "Todas",
    proyecto: "proyecto",
    proyectosPlural: "proyectos",
    tituloInicio: "Portafolio",
    tituloProyectos: "Proyectos",
    tema: { aOscuro: "Cambiar a modo oscuro", aClaro: "Cambiar a modo claro" },
    idioma: { cambiar: "Ver en inglés (EN)", etiqueta: "EN" },
    redes: { email: "Email", web: "Sitio web" },
    form: {
      nombre: "Nombre",
      nombrePh: "Tu nombre",
      email: "Email",
      emailPh: "nombre@mail.com",
      mensaje: "Mensaje",
      mensajePh: "Contame en qué puedo ayudarte",
      enviar: "Enviar mensaje",
      enviando: "Enviando…",
      ok: "¡Gracias! Tu mensaje fue enviado.",
      error: "No se pudo enviar. Probá de nuevo o escribime directo al email.",
      asunto: "Nuevo mensaje desde el portafolio",
      errores: {
        nombreVacio: "Ingresá tu nombre.",
        nombreInvalido: "El nombre solo puede tener letras y espacios.",
        emailVacio: "Ingresá tu email.",
        emailInvalido: "Revisá el email, parece incompleto (ej: nombre@mail.com).",
        mensajeVacio: "Escribí un mensaje.",
        mensajeLargo: (max) => `El mensaje no puede superar los ${max} caracteres.`,
      },
    },
  },
  en: {
    saltarContenido: "Skip to content",
    menuAbrir: "Open menu",
    menuCerrar: "Close menu",
    navPrincipal: "Main",
    inicio: "home",
    nav: { sobreMi: "About", proyectos: "Projects", skills: "Skills", contacto: "Contact" },
    cv: "Resume",
    descargarCv: "Download resume",
    cvOtroIdioma: "Resume (ES)",
    descargarCvOtroIdioma: "Download resume (Spanish)",
    verProyectos: "See projects",
    verTodos: "View all",
    verDemo: "Live demo",
    codigo: "Code",
    de: "for",
    abreNuevaPestana: "opens in a new tab",
    capturaDe: "Screenshot of",
    tecnologias: "Technologies",
    volverInicio: "Back to home",
    todosLosProyectos: "All projects",
    filtrarPorTecnologia: "Filter by technology",
    todas: "All",
    proyecto: "project",
    proyectosPlural: "projects",
    tituloInicio: "Portfolio",
    tituloProyectos: "Projects",
    tema: { aOscuro: "Switch to dark mode", aClaro: "Switch to light mode" },
    idioma: { cambiar: "View in Spanish (ES)", etiqueta: "ES" },
    redes: { email: "Email", web: "Website" },
    form: {
      nombre: "Name",
      nombrePh: "Your name",
      email: "Email",
      emailPh: "name@mail.com",
      mensaje: "Message",
      mensajePh: "Tell me how I can help",
      enviar: "Send message",
      enviando: "Sending…",
      ok: "Thanks! Your message has been sent.",
      error: "The message couldn't be sent. Try again or email me directly.",
      asunto: "New message from the portfolio",
      errores: {
        nombreVacio: "Please enter your name.",
        nombreInvalido: "Your name can only contain letters and spaces.",
        emailVacio: "Please enter your email.",
        emailInvalido: "This email looks incomplete (e.g. name@mail.com).",
        mensajeVacio: "Please write a message.",
        mensajeLargo: (max) => `Your message can't be longer than ${max} characters.`,
      },
    },
  },
};
